import React from 'react';

import { SVGComponentProps } from './svg.types';

const ArrowUpSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        className="cursor-pointer"
        width="6"
        height="4"
        viewBox="0 0 6 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25868 3.71215C5.10163 3.71349 4.94994 3.65227 4.83421 3.54083L3.00003 1.71972L1.16584 3.54083C1.05046 3.65241 0.899297 3.71436 0.742393 3.71436C0.58549 3.71436 0.434329 3.65241 0.318947 3.54083C0.26346 3.48747 0.219155 3.42258 0.188845 3.35029C0.158535 3.27799 0.142883 3.19987 0.142883 3.12089C0.142883 3.04191 0.158535 2.96379 0.188845 2.8915C0.219155 2.8192 0.26346 2.75431 0.318947 2.70095L2.57678 0.460108C2.6917 0.348061 2.84275 0.285784 2.99962 0.285784C3.15648 0.285784 3.30754 0.348061 3.42245 0.460108L5.68111 2.69881C5.73659 2.75217 5.7809 2.81706 5.81121 2.88935C5.84152 2.96165 5.85717 3.03977 5.85717 3.11875C5.85717 3.19773 5.84152 3.27585 5.81121 3.34814C5.7809 3.42044 5.73659 3.48533 5.68111 3.53869C5.56612 3.64999 5.41511 3.71123 5.25868 3.71001"
          fill="white"
        />
      </svg>
    </span>
  );
};

export default ArrowUpSVG;
